import React from 'react';

export const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const base = "inline-flex items-center justify-center font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-padua-green text-white hover:bg-padua-green/90 shadow-sm",
    secondary: "bg-padua-gold text-white hover:bg-padua-gold/90 shadow-sm",
    outline: "border-2 border-padua-green text-padua-green hover:bg-padua-green/5",
    ghost: "text-padua-green hover:bg-padua-green/10",
    large: "text-lg py-4 px-8 rounded-xl shadow-md", // specifically for iPad touch targets
  };

  const sizes = {
    sm: "text-sm py-1.5 px-3 rounded-md",
    md: "text-base py-2.5 px-5 rounded-lg",
    lg: "text-lg py-3.5 px-6 rounded-xl",
  };

  // If the variant string contains 'large', we use a special combo
  const isLarge = variant.includes('large');
  const sizeClass = isLarge ? '' : sizes.md;
  const variantClass = isLarge ? variants.primary + ' ' + variants.large : variants[variant] || variants.primary;

  return (
    <button className={`${base} ${variantClass} ${sizeClass} ${className}`} {...props}>
      {children}
    </button>
  );
};